/*!
 * All material copyright ESRI, All Rights Reserved, unless otherwise specified.
 * See https://github.com/Esri/calcite-design-system/blob/dev/LICENSE.md for details.
 * v2.10.1
 */
import { T as TableHeader, d as defineCustomElement$1 } from './table-header.js';

const CalciteTableHeader = TableHeader;
const defineCustomElement = defineCustomElement$1;

export { CalciteTableHeader, defineCustomElement };

//# sourceMappingURL=calcite-table-header.js.map